import qrcode from '@itau-loans-www/assets/images/wpp-qrcode-fgts.png'

export default {
  qrcode,
  title: 'Escaneie o QRCode e contrate direto pelo whatsapp',
  description:
    'Para antecipar seu Saque-Aniversário pelo whatsapp, abra a câmera e aponte o seu celular para o QRCode ou adicione o número (11) 4004-4828 em seus contatos.'
}
